<template>
  <mw-dialog ref="dialog" size="form" :appendToBody="false" :title="title" :footerButton="footerButton"  customClass="mw-flow-complete"  :beforeClose="beforeClose">
    <div class="__form_content">
      <template v-if="false">
         <div class="__sel"> <span class="__btn">{{$lang("未获取到符合条件的流向信息")}}</span></div>
      </template>
      <template v-for="flow in workFlows">
          <mw-wt-tree :rowStyle="rowStyle" :flowId="flow.id" :flowName="flow.name"
                      :flowType="flow.type" :params="params" :activityId="flow.activityId" :url="flow.url"
                      :doings="doings[flow.id]" :finisheds="flow.finisheds" :options="flow.options"></mw-wt-tree>
      </template>
    </div>
  </mw-dialog>
</template>
<script>
import MwWtTree from "./worktrack/treewt.vue";

export default {
  components: {
    MwWtTree
  },
  props: {
    params: {
      type: Object
    }
  },
  data() {
    let me=this;
    return {
      title:$lang('运转跟踪'),
      fCount:0,
      workFlows:[],
      doings:{},
      rowStyle:'height:225px; padding-top:5px;',
      footerButton: [
        {
          label: $lang("取消"),
          type: "default",
          func:me.close
        }
      ]
    }
  },
  mounted() {
    setTimeout(()=>{
      this.show();
    },200)
    this.init();
  },
  watch: {
    params(){
      this.init();
    }
  },
  methods: {
    init(){
      var me = this;
      me.mwApi.process.getWorkFlowTrees({taskId:me.params.taskId}).then((data)=>{
         let res=data.result;
         if(typeof res.success !='undefined' && !res.success){
            me.fCount = 0;
            return;
         }
         me.workFlows = res;
         me.fCount = res.length;
         me.rowStyle='height:'+Math.floor(100/me.fCount)+'%; padding-top:5px;';
         me.workFlows.map((wf)=>{
           wf.url="/rest/process/task/flow/"+me.params.taskId+"/"+wf.id+`?_=${Math.random()}`;
           var fdoings=[];
           if(wf.doings){ //在办
             wf.doings.map((v)=>{
               var node = me._subPlannedAsNode(v);
               node.flowId = wf.id;
               fdoings.push(node);
             });
           }
           me.doings[wf.id]=fdoings;
         });
      });
    },
    beforeClose(done){
      var me = this;
      me.mwConfirm($lang('确定退出运转跟踪窗口？')).then(_=>{
        if(me.params.secondfunc){
          me.params.secondfunc();
        }
        me.resetForm();
        done();
      }).catch(_=>{});
    },
    formActionComplete(){
      var me = this;
      if(me.params.func){
        me.params.func();
      }
      this.resetForm();
    },
    close(){
      this.resetForm();
      this.mwRef('dialog').hide();
    },
    show(){
      this.mwRef('dialog').show();
    },
    resetForm(){
      var me = this;
      me.workFlows = [];
      me.doings = {};
      me.fCount=0;
      me.rowStyle='height:225px; padding-top:5px;';
    },
     _subPlannedAsNode(v){
       var node = {};
       node.id=v.masterObjectId;
       node.name=v.masterObjectName;
       if(v.masterObjectType=='USER'){
         node.type = 'U';
         node.departmentId = v.masterObjectDeptId;
       }else{
         node.type='D';
       }
       if(v.identities){
         node.identities = v.identities;
       }
       node.text = v.masterObjectName;
       return node;
     }
  }
}
</script>





// WEBPACK FOOTER //
// src/common/components/public-dialog/worktrackTree.vue